import WorkspaceDashboard from 'components/Dashboard/WorkspaceDashboard.vue';
import AssignedReviews from 'components/InspectionCampaigns/AssignedReviews.vue';
import GenericSnackBar from 'components/GenericSnackbar/GenericSnackBar.vue';
import SmartdataLanding from 'components/Landing/SmartdataLanding.vue';
import 'driver.js/dist/driver.css';
import { startHomeDashboardTour } from 'js/onboarding/homeDashboardTour';
import { createApp } from 'vue';
import mainMixin, { registerApp } from 'js/mixins/mainMixin';

function readHomeDashboardData() {
    const payloadNode = document.querySelector('#home-dashboard-data');
    if (!payloadNode) {
        return {
            dashboardSummary: {},
            recentViews: [],
            recentlyUploaded: [],
            favouriteViews: [],
        };
    }

    try {
        return JSON.parse(payloadNode.textContent);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to parse home dashboard payload', error);
        return {
            dashboardSummary: {},
            recentViews: [],
            recentlyUploaded: [],
            favouriteViews: [],
        };
    }
}

const mountEl = document.querySelector('#MainApp');
if (!mountEl) {
    // eslint-disable-next-line no-console
    console.warn('Skipping Home mount: #MainApp not found');
} else {
    if (mountEl.querySelector('[data-sd-skip-shell-bootstrap]')) {
        window.SD_SKIP_SHELL_BOOTSTRAP = true;
    }

    const initialDashboardData = readHomeDashboardData();
    const app = createApp({
        name: 'Home',
        components: {
            AssignedReviews,
            WorkspaceDashboard,
            GenericSnackBar,
            SmartdataLanding,
        },
        mixins: [mainMixin],
        data() {
            return {
                dashboardSummary: initialDashboardData.dashboardSummary || {},
                recentViews: initialDashboardData.recentViews || [],
                recentlyUploaded: initialDashboardData.recentlyUploaded || [],
                favouriteViews: initialDashboardData.favouriteViews || [],
            };
        },
        computed: {},
        watch: {},
        mounted() {
            startHomeDashboardTour({
                context: {
                    user: window.USER || '',
                },
            });
        },
        methods: {
            snack(message) {
                this.$refs.snack.show(message);
            },
        },
    });
    registerApp(app);
    app.mount(mountEl);
}
